import { render, staticRenderFns } from "./PrivateEconomy.vue?vue&type=template&id=3dbc2ef0&scoped=true"
import script from "./PrivateEconomy.vue?vue&type=script&lang=js"
export * from "./PrivateEconomy.vue?vue&type=script&lang=js"
import style0 from "./PrivateEconomy.vue?vue&type=style&index=0&id=3dbc2ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbc2ef0",
  null
  
)

export default component.exports